import request from '@a/js/request'

// 创建订单
export function CreateOrder(params) {
  return request({
    url: '/g/v1/temp/ieee_order',
    method: 'post',
    data: params,
  })
}

// 取消订单
export function CancleOrder(params) {
  return request({
    url: '/g/v1/pay/order/cancel/business',
    method: 'put',
    data: params,
  })
}

// 查询订单状态
export function GetOrderStatus(query) {
  return request({
    url: '/g/v1/temp/ieee_order',
    method: 'get',
    params: query,
  })
}

// 查询订单状态-com
export function GetOrderStatuscom(query) {
  return request({
    url: '/c/ticket/v1/order/status',
    method: 'get',
    params: query,
  })
}